module.exports = __webpack_public_path__ + "static/media/covi@2x.399db429.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/complex/onboarding/covi@2x.png
// module id = 2201
// module chunks = 1